<template>
    <div class="main-grids">
        <div class="recommended">
            <div class="recommended-grids">
                <div class="recommended-info">
                    <h3>{{ listTitle }}</h3>
                </div>
                <layoutVideo :data="videoList"></layoutVideo>
            </div>
            <div class="page__content">
                <pagination :per-page="pageSize" :records="videoListTotal" v-model="page" :options="pageOptions" @paginate="myCallback"></pagination>
            </div>
        </div>
    </div>
</template>

<script>
import layoutVideo from '@/components/VideoList'

export default {
  name: '',
  data () {
    return {
      listTitle: '',
      videoList: [],
      videoListTotal: 0,
      page: parseInt(this.$route.query.p) || 1,
      pageSize: 8,
      pageRecords: 0,
      pageOptions: {
        chunk: 10,
        theme: 'bootstrap3',
        texts: {
          count: '顯示 {from} 到 {to} 筆 / 總共 {count} 筆|總共 {count} 筆|總共 {count} 筆'
        }
      }
    }
  },
  props: ['meta'],
  components: {
    layoutVideo
  },
  watch: {
    '$route' (to, from) {
      this.listTitle = ''
      this.videoList = []
      this.page = parseInt(this.$route.query.p) || 1
      this.pageRecords = 0
      this.videoListTotal = 0
      this.$nextTick(() => {
        this.searchVideos()
      })
    }
  },
  mounted () {
    this.searchVideos()
  },
  methods: {
    searchVideos: function () {
      let self = this
      this.$http.get('/searchVideos/' + self.pageSize + '/' + self.page + '?q=' + encodeURIComponent(self.$route.query.q)).then(function (response) {
        self.listTitle = '查詢：' + self.$route.query.q
        self.videoList = response.data.list
        self.videoListTotal = response.data.total
        self.page = parseInt(self.page)
      })
    },
    myCallback: function (page) {
      let self = this
      self.$router.push({ name: 'VideoSearch', query: { q: self.$route.query.q, p: page } })
    }
  },
  metaInfo () {
    return {
      titleTemplate: this.$route.query.q + ' - %s'
    }
  }
}

</script>
